import "../styles/AquaFlowPromo.scss";
import aquaflow from "../assets/marketing/piscina.png";
import aquaflow_graph from "../assets/marketing/psicina_graph.png";

const Piscina = () => {
  return (
    <section className="aqua-flow-promo">
      <img src={aquaflow} alt="Aqua Flow Banner" className="top-image" />

      <div className="features">
        <div>
          <h3>MATERIAL ATÓXICO</h3>
          <p>
            Materiais atóxicos não contêm substâncias químicas prejudiciais à
            saúde, o que significa que não há risco de contaminação da água da
            piscina por essas substâncias. Além disso, esses materiais são
            duráveis e resistentes à corrosão, o que reduz a necessidade de
            manutenção e reparos.
          </p>
        </div>
        <div>
          <h3>PISCINA AQUECIDA COM FACILIDADE</h3>
          <p>
            Tenha todo o conforto e economia de uma piscina aquecida utilizando
            apenas a luz do sol como fonte de energia.
          </p>
        </div>
        <div>
          <h3>ANTI-REAGENTE</h3>
          <p>
            Não reage a produtos químicos utilizados no tratamento de piscina
          </p>
        </div>
      </div>

      <div className="button-wrapper">
        <a
          href={`https://wa.me/555391425203?text=Olá%2C+tenho+interesse+em+seus+serviços+de+${"coletor+solar+de+piscina"}.`}
          target="_blank"
          style={{ color: "inherit" }}
        >
          <button>Solicite seu orçamento</button>
        </a>
      </div>

      <img
        src={aquaflow_graph}
        alt="Gráfico de desempenho"
        className="bottom-image"
      />
    </section>
  );
};

export default Piscina;
